export default "__VITE_ASSET__C42sc1RO__"